'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PencilEdit = require('./PencilEdit');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PencilEdit).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/PencilEdit/index.js
// module id = 1252
// module chunks = 1